// extracted by mini-css-extract-plugin
export var section = "localAttractions-module--section--cd879";